module.exports = __webpack_public_path__ + "static/media/banner.d6dc82fa.png";